import React from 'react';
import Websocket from 'react-websocket';

const websocket_url = 'wss://'+process.env.REACT_APP_PK_ENV+'websocket.pechakucha.com';

class PKWebSocket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      complete_url: ''
    };
  }
  
  componentDidMount() {
    this.setState({
      complete_url: websocket_url+'?user_uuid='+this.props.user_uuid+'&user_token='+this.props.user_token.substring(7)
    });
  }

  handleOpen() {
    console.log("websocket handleOpen");
  }

  handleClose() {
    console.log("websocket handleClose");
  }

  handleData(data) {
    console.log("websocket handleData",data);
    let result = JSON.parse(data);
    if (result.type === 'ring') {
      if (this.props.OnRing) {
        if (result.data) {
          this.props.OnRing(result.data);
        }
      }
    } else if (result.type === 'update_user_context') {
      if (this.props.OnUpdateUserContext) {
        if (result.data) {
          this.props.OnUpdateUserContext(result.data);
        }
      }
    } else {
      // not supported
    }
  }

  render() {
    return (
      <React.Fragment>
      { this.state.complete_url &&
        <Websocket
          url={this.state.complete_url}
          onMessage={this.handleData.bind(this)}
          onOpen={this.handleOpen.bind(this)}
          onClose={this.handleClose.bind(this)}
          reconnect={true}
          debug={true}
        />
      }
      </React.Fragment>
    );
  }
}

export default PKWebSocket;
  
